<script setup lang="ts">
import {
  DialogSize,
  KButton,
  KConfirmDialog,
} from "@kaleidoscope-solutions/ks-design-system"
import { closeDialog } from "vue3-promise-dialog"

const props = withDefaults(defineProps<DialogProps>(), {
  size: DialogSize.small,
  okButton: "OK",
  cancelButton: "Cancel",
})

export interface DialogProps {
  title: string
  body: string | string[]
  size?: DialogSize
  okButton?: string
  okButtonRed?: boolean
  cancelButton?: string
  hideCancelButton?: boolean
}

const body = Array.isArray(props.body) ? props.body : [props.body]
</script>

<template>
  <KConfirmDialog
    :open="true"
    :size="size"
  >
    <template #default>
      <h2 class="mb-4 text-xl font-bold">
        {{ title }}
      </h2>
      <div
        v-for="text in body"
        :key="text"
        class="h-full"
      >
        <p>{{ text }}</p>
      </div>
      <div class="flex w-full justify-end gap-4">
        <KButton
          v-if="!hideCancelButton"
          variety="secondary"
          color="violet"
          data-test="promise-dialog-btn-cancel"
          @click="closeDialog(false)"
        >
          {{ cancelButton }}
        </KButton>
        <KButton
          :color="okButtonRed ? 'red' : 'violet'"
          data-test="promise-dialog-btn-ok"
          @click="closeDialog(true)"
        >
          {{ okButton }}
        </KButton>
      </div>
    </template>
  </KConfirmDialog>
</template>
